import { EstadoEntidade } from "@/shared/enumeradores";
import axios from "./axios-handler.service";
import { Revista } from "./revistas.service";
import { Paginacao } from "@/shared/interface";
const BASE_URL = "/api/Catalogos";

export interface Catalogo {
  estadoEntidade: EstadoEntidade;
  idCatalogo: string;
  idFornecedor: string;
  nome: string;
  descricao: string;
  tipo: string;
  dataCriacao: string;
  ativo: boolean;
  prioridade?: number | null;
  imagemDestaque?: string | null;
  imagemDestaqueCompleta?: string | null;
  revistaAtiva: Revista;
  ehMaryKay: boolean;
}

export interface ComponenteCatalogo {
  idCatalogo: string;
  idHistoricoProduto: string;
  idProduto: string;
  codigoFornecedor: string;
  descricao: string;
  valorVenda: number;
  validoDe: string;
  validoAte: string;
  dataAlteracao: string;
  imagem: string;
  excluido: boolean;
  categoria: string;
}

export interface FiltroCatalogo {
  term: string;
  somenteAtivos: boolean;
  offset: number;
  limit: number;
  order?: string;
}

export class CatalogosService {
  static async listarCatalogosGlobaisPaginado(filtro: FiltroCatalogo): Promise<Paginacao<Catalogo>> {
    const {term, somenteAtivos, offset, limit, order} = filtro;
    const response = await axios.get<Paginacao<Catalogo>>(`${BASE_URL}/ListarCatalogosGlobais`,{
      params: { 
        txtPesquisa: term, 
        ativo: somenteAtivos, 
        offset, 
        limit, 
        order 
      },
    });
    return response.data;
  }

  static async listarCatalogosGlobais(): Promise<Catalogo[]> {
    const response = await axios.get<Catalogo[]>(`${BASE_URL}/ListarTodosCatalogosGlobais`);
    return response.data;
  }

  static async obterCatalogo(idCatalogo: string): Promise<Catalogo> {
    const response = await axios.get<Catalogo>(`${BASE_URL}/ObterCatalogo`, {
      params: { idCatalogo },
    });
    return response.data;
  }

  static async manterCatalogo(
    catalogo: Catalogo,
    imagemDestaqueBase64: string
  ): Promise<void> {
    await axios.post(BASE_URL + "/ManterCatalogo", {
      catalogo,
      imagemDestaqueBase64,
    });
  }
  static async excluirImagemDestaque(idCatalogo: string): Promise<void> {
    await axios.post(`${BASE_URL}/ExcluirImagemDestaque`, { idCatalogo });
  }
  static async deletarCatalogo(idCatalogo: string): Promise<void> {
    const response = await axios.post(`${BASE_URL}/Deletar`, {
      idCatalogo,
    });
    return response.data;
  }
}
